import { render, staticRenderFns } from "./AlertOverview.vue?vue&type=template&id=c2c0f0dc&scoped=true&"
import script from "./AlertOverview.vue?vue&type=script&lang=js&"
export * from "./AlertOverview.vue?vue&type=script&lang=js&"
import style0 from "./AlertOverview.vue?vue&type=style&index=0&id=c2c0f0dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c0f0dc",
  null
  
)

export default component.exports